import { useMemo, useState } from "react";
import type { MunicipioResumido } from "../../../shared/tipos";
import { semAutocompletar } from "./ui";

/**
 * Campo de busca com sugestões para Município (a lista tem 415 itens — ruim
 * como <select> simples). Digite 3+ letras que já filtra e mostra sugestões.
 * Port de static/js/municipio-busca.js.
 */
function normalizarTexto(s: string) {
  return (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

interface Props {
  municipios: MunicipioResumido[];
  valor: number | null;
  onChange: (id: number | null) => void;
  rotulo: string;
}

export function MunicipioBusca({ municipios, valor, onChange, rotulo }: Props) {
  const nomeInicial = municipios.find((m) => m.id === valor)?.nome ?? "";
  const [texto, setTexto] = useState(nomeInicial);
  const [aberto, setAberto] = useState(false);

  const encontrados = useMemo(() => {
    const termo = normalizarTexto(texto.trim());
    if (termo.length < 3) return [];
    return municipios.filter((m) => normalizarTexto(m.nome).includes(termo)).slice(0, 20);
  }, [texto, municipios]);

  return (
    <label style={{ position: "relative" }}>
      {rotulo}
      <input
        type="search"
        placeholder="digite 3+ letras..."
        value={texto}
        {...semAutocompletar}
        onChange={(ev) => {
          setTexto(ev.target.value);
          onChange(null);
          setAberto(true);
        }}
        onFocus={() => setAberto(true)}
        onBlur={() => setTimeout(() => setAberto(false), 150)}
      />
      <div className={`ac-list${aberto && encontrados.length ? " show" : ""}`}>
        {encontrados.map((m) => (
          <div
            key={m.id}
            className="ac-item"
            onMouseDown={(ev) => {
              ev.preventDefault();
              setTexto(m.nome);
              onChange(m.id);
              setAberto(false);
            }}
          >
            {m.nome}
          </div>
        ))}
      </div>
    </label>
  );
}
